import { render, staticRenderFns } from "./Visadata.vue?vue&type=template&id=649676c4"
import script from "./Visadata.vue?vue&type=script&lang=js"
export * from "./Visadata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports